import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/en/services/one-vigilance/qppv-local-representative")({
  head: () => buildRouteHead("/en/services/one-vigilance/qppv-local-representative", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ to: "/en/services/pharmacovigilance/qppv-local-representative", replace: true });
  },
});
